import Form from 'antd/lib/form/Form'
import './index.less'

export default Form



// WEBPACK FOOTER //
// ./src/elements/form/index.js